import { FEATURES, SMB_BASE } from './features.js';

export { SMB_BASE };

/** Canonical host. www.revetall.ai, revetall.no and www.revetall.no redirect here. */
export const SITE_ORIGIN = 'https://revetall.ai';

/** Share image for link previews (LinkedIn, Slack, Messenger …): 1200 × 630. */
export const OG_IMAGE = `${SITE_ORIGIN}/share-image.png`;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;

/** The logo: the word «revetall», for structured data. */
export const LOGO_IMAGE = `${SITE_ORIGIN}/revetall-logo.png`;

export const ABOUT_PATH = `${SMB_BASE}/om-oss`;

/**
 * Old paths that now live under SMB_BASE. Render and the app both redirect these.
 * @type {Array<{from: string, to: string}>}
 */
export const LEGACY_REDIRECTS = [
  ...FEATURES.map((feature) => ({
    from: feature.path.slice(SMB_BASE.length),
    to: feature.path,
  })),
  { from: '/om-oss', to: ABOUT_PATH },
];

/**
 * Pages search engines and answer engines should fetch.
 * `/` is the groups page. The SMB home, feature pages and about page live under SMB_BASE.
 * @type {Array<{path: string, id: string}>}
 */
export const INDEXED_PAGES = [
  { path: '/', id: 'groups' },
  { path: SMB_BASE, id: 'home' },
  ...FEATURES.map((feature) => ({ path: feature.path, id: feature.id })),
  { path: ABOUT_PATH, id: 'about' },
];
